// Footer.jsx
import { useState } from "react";

export default function Footer() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Handle Input Changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id === "footerName" ? "name" : id === "footerEmail" ? "email" : "message"]: value
    }));
    // Clear error when user starts typing
    if (errors[id]) {
      setErrors(prev => ({ ...prev, [id]: "" }));
    }
  };

  // Validate Form
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.footerName = "Name is required";
    if (!formData.email.trim()) {
      newErrors.footerEmail = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.footerEmail = "Email is invalid";
    }
    if (!formData.message.trim()) newErrors.footerMessage = "Message is required";
    return newErrors;
  };

  // Handle Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length === 0) {
      // Form is valid - submit logic here
      console.log("Form Data:", formData);
      setIsSubmitted(true);
      setFormData({ name: "", email: "", message: "" });
      
      // Hide success message after 3 seconds
      setTimeout(() => setIsSubmitted(false), 3000);
      
      // Here you can make an API call to send data
      // fetch('/api/contact', { method: 'POST', body: JSON.stringify(formData) })
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <footer className="fixed-box bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white mt-auto">
      <div className="container mx-auto px-4 py-12 md:py-16">
        
        {/* Get In Touch Section */}
        <div className="text-center mb-12">
          <div className="bottom-box-title">
            <h3 className="text-3xl md:text-4xl font-bold mb-3 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Get In Touch
            </h3>
            <span className="under_line block w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full"></span>
          </div>
        </div>

        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="max-w-3xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            {/* Name Field */}
            <div className="form-control">
              <label 
                htmlFor="footerName" 
                className="block text-sm font-medium mb-2 text-gray-300"
              >
                Name:
              </label>
              <input 
                id="footerName" 
                type="text" 
                value={formData.name}
                onChange={handleChange}
                className={`w-full px-4 py-3 bg-gray-800 border ${
                  errors.footerName ? 'border-red-500' : 'border-gray-700'
                } rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-300 text-white`}
                placeholder="Enter your name"
              />
              {errors.footerName && (
                <p className="text-red-500 text-xs mt-1">{errors.footerName}</p>
              )}
            </div>

            {/* Email Field */}
            <div className="form-control">
              <label 
                htmlFor="footerEmail" 
                className="block text-sm font-medium mb-2 text-gray-300"
              >
                Email:
              </label>
              <input 
                id="footerEmail" 
                type="email" 
                value={formData.email}
                onChange={handleChange}
                className={`w-full px-4 py-3 bg-gray-800 border ${
                  errors.footerEmail ? 'border-red-500' : 'border-gray-700'
                } rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-300 text-white`}
                placeholder="Enter your email"
              />
              {errors.footerEmail && (
                <p className="text-red-500 text-xs mt-1">{errors.footerEmail}</p>
              )}
            </div>
          </div>

          {/* Message Field */}
          <div className="mb-8">
            <div className="form-control">
              <label 
                htmlFor="footerMessage" 
                className="block text-sm font-medium mb-2 text-gray-300"
              >
                Message:
              </label>
              <textarea 
                id="footerMessage" 
                rows="4" 
                value={formData.message}
                onChange={handleChange}
                className={`w-full px-4 py-3 bg-gray-800 border ${
                  errors.footerMessage ? 'border-red-500' : 'border-gray-700'
                } rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-300 text-white resize-none`}
                placeholder="Write your message here..."
              ></textarea>
              {errors.footerMessage && (
                <p className="text-red-500 text-xs mt-1">{errors.footerMessage}</p>
              )}
            </div>
          </div>

          {/* Submit Button */}
          <div className="text-center mb-12">
            <button 
              type="submit"
              className="send-btn px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
              id="footerBtn"
            >
              SEND MESSAGE
            </button>
            
            {/* Success Message */}
            {isSubmitted && (
              <div className="mt-4 p-3 bg-green-500/20 border border-green-500 rounded-lg text-green-400 animate-pulse">
                ✓ Message sent successfully!
              </div>
            )}
          </div>
        </form>

        {/* Copyright Section */}
        <div className="text-center pt-8 border-t border-gray-800">
          <p className="copyright text-gray-400 text-sm">
            2008-2019 @ Anabolic Pharma Pvt., LTD. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}